import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Button from '../elements/Button';
import { useLanguage } from '../../contexts/LanguageContext';
import useIsMobile from '../../utils/useIsMobile';

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool,
};

const defaultProps = {
  ...SectionProps.defaults,
  split: false,
};

const Cta = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {
  const outerClasses = classNames(
    'cta section cta-overhaul',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className,
  );

  const innerClasses = classNames(
    'cta-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
    split && 'cta-split',
  );

  const { lang } = useLanguage();
  const isMobile = useIsMobile();
  const webWaUrl =
    'https://web.whatsapp.com/send?phone=19544708414&text=Hello,%20I%20want%20to%20know%20more%20about%20an%20AI%20agent%20for%20my%20Moodle%20course.';
  const mobileWaUrl =
    'whatsapp://send?phone=19544708414&text=Hello,%20I%20want%20to%20know%20more%20about%20an%20AI%20agent%20for%20my%20Moodle%20course.';

  const content = {
    en: {
      label: "Let's Talk",
      title: 'Ready to put an AI tutor inside your Moodle course?',
      sub: 'We connect the course, index the material, and the agent goes live inside Moodle.',
      btn: 'Start on WhatsApp',
      btnEmail: 'Send an Email',
    },
    es: {
      label: 'Hablemos',
      title: '¿Listo para poner un tutor de IA dentro de tu curso en Moodle?',
      sub: 'Conectamos el curso, indexamos el material y el agente queda activo dentro de Moodle.',
      btn: 'Empezar por WhatsApp',
      btnEmail: 'Enviar Email',
    },
  };

  const c = content[lang];

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <span className="section-label">{c.label}</span>
          <h3 className="mt-8 mb-0">{c.title}</h3>
          <p className="cta-sub">{c.sub}</p>
          <div
            style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginTop: '24px',
            }}
          >
            <Button
              tag="a"
              color="primary"
              href={isMobile ? mobileWaUrl : webWaUrl}
              target="_blank"
            >
              {c.btn}
            </Button>
            <Button
              tag="a"
              href="mailto:info@e-comienza.com"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.15)',
                color: '#ECEDED',
                borderRadius: '100px',
                padding: '14px 32px',
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {c.btnEmail}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;
